import { useTranslation } from 'react-i18next';
import { useLocalizedPath } from '../../../hooks/useLocalizedPath';
import { Link } from 'react-router-dom';
import { Package, ShieldCheck, Zap, ArrowRight } from 'lucide-react';
import { Section, Container, Button } from '../../ui';
import { IllustrationBusinessModel } from '../../icons';
import styles from './BusinessModel.module.css';

const featureIcons = [Package, ShieldCheck, Zap];

export function BusinessModel() {
  const { t } = useTranslation('home');
  const { lp } = useLocalizedPath();

  const cards = t('businessModel.cards', { returnObjects: true }) as {
    title: string; text: string; tagline: string;
  }[];

  return (
    <Section variant="light">
      <Container>
        <div className={styles.splitGrid}>
          <div className={styles.illustrationCol}>
            <IllustrationBusinessModel className={styles.illustration} />
          </div>

          <div className={styles.contentCol}>
            <span className={styles.badge}>{t('businessModel.badge')}</span>
            <h2 className={styles.heading}>{t('businessModel.heading')}</h2>
            <p className={styles.subtitle}>{t('businessModel.subtitle')}</p>

            <div className={styles.features}>
              {cards.map((card, i) => {
                const Icon = featureIcons[i];
                return (
                  <div key={i} className={styles.featureItem}>
                    <div className={styles.featureIcon}>
                      <Icon size={20} strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className={styles.featureTitle}>{card.title}</h3>
                      <p className={styles.featureTagline}>{card.tagline}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className={styles.actions}>
              <Button href="https://www.qbp.solutions/solutions/business-model">{t('businessModel.ctaPrimary')}</Button>
              <Link to={lp('/contact')} className={styles.secondaryLink} data-attr="cta-contact">
                {t('businessModel.ctaSecondary')}
                <ArrowRight size={16} strokeWidth={1.5} />
              </Link>
            </div>

            <p className={styles.hook}>{t('businessModel.hook')}</p>
          </div>
        </div>
      </Container>
    </Section>
  );
}
